/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvseType } from './EvseType';
import {
    EvseTypeFromJSON,
    EvseTypeFromJSONTyped,
    EvseTypeToJSON,
    EvseTypeToJSONTyped,
} from './EvseType';

/**
 * 
 * @export
 * @interface UpdateAssetRequestDto
 */
export interface UpdateAssetRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    assetName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    serialNumber?: string;
    /**
     * Organization business identifier (e.g. CH-001)
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    tenantAssetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    manufacturerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    siteId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    zoneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    assetTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    assetModelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    parentAssetId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAssetRequestDto
     */
    installedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAssetRequestDto
     */
    commissionedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAssetRequestDto
     */
    decommissionedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAssetRequestDto
     */
    expectedDailyEarning?: number;
    /**
     * 
     * @type {EvseType}
     * @memberof UpdateAssetRequestDto
     */
    standard?: EvseType | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetRequestDto
     */
    landlordOrganizationId?: string | null;
}



/**
 * Check if a given object implements the UpdateAssetRequestDto interface.
 */
export function instanceOfUpdateAssetRequestDto(value: object): value is UpdateAssetRequestDto {
    return true;
}

export function UpdateAssetRequestDtoFromJSON(json: any): UpdateAssetRequestDto {
    return UpdateAssetRequestDtoFromJSONTyped(json, false);
}

export function UpdateAssetRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssetRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetName': json['assetName'] == null ? undefined : json['assetName'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'tenantAssetId': json['tenantAssetId'] == null ? undefined : json['tenantAssetId'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
        'assetTypeId': json['assetTypeId'] == null ? undefined : json['assetTypeId'],
        'assetModelId': json['assetModelId'] == null ? undefined : json['assetModelId'],
        'parentAssetId': json['parentAssetId'] == null ? undefined : json['parentAssetId'],
        'installedAt': json['installedAt'] == null ? undefined : (new Date(json['installedAt'])),
        'commissionedAt': json['commissionedAt'] == null ? undefined : (new Date(json['commissionedAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'expectedDailyEarning': json['expectedDailyEarning'] == null ? undefined : json['expectedDailyEarning'],
        'standard': json['standard'] == null ? undefined : EvseTypeFromJSON(json['standard']),
        'landlordOrganizationId': json['landlordOrganizationId'] == null ? undefined : json['landlordOrganizationId'],
    };
}

export function UpdateAssetRequestDtoToJSON(json: any): UpdateAssetRequestDto {
    return UpdateAssetRequestDtoToJSONTyped(json, false);
}

export function UpdateAssetRequestDtoToJSONTyped(value?: UpdateAssetRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'tenantAssetId': value['tenantAssetId'],
        'manufacturerId': value['manufacturerId'],
        'siteId': value['siteId'],
        'zoneId': value['zoneId'],
        'assetTypeId': value['assetTypeId'],
        'assetModelId': value['assetModelId'],
        'parentAssetId': value['parentAssetId'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'commissionedAt': value['commissionedAt'] == null ? value['commissionedAt'] : value['commissionedAt'].toISOString(),
        'decommissionedAt': value['decommissionedAt'] == null ? value['decommissionedAt'] : value['decommissionedAt'].toISOString(),
        'expectedDailyEarning': value['expectedDailyEarning'],
        'standard': EvseTypeToJSON(value['standard']),
        'landlordOrganizationId': value['landlordOrganizationId'],
    };
}

